import * as types from '../constants';

const initialState = {
  filters: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FILTER:
      return {
        ...state,
        filters: {
          ...action.payload,
        },
      };

    case types.RESET_FILTER:
      return {
        ...state,
        filters: {},
      };

    default:
      return state;
  }
};

export default reducer;
